import React from 'react'
import styles from '../Map/Map.module.scss'
import PropTypes from 'prop-types'
import { ReactComponent as ArrowRight } from '../../../assets/media/icons/icon-arrow-right.svg'
import LocationAddress from '../../LocationDetails/LocationAddress/LocationAddress'

const InfoWindowBody = ({ location, localizations, onDetailsClick }) => {
    const address = {
        state: location?.state,
        compliment: location?.compliment,
        postalCode: location?.postalCode,
        street: location?.street,
        city: location?.city,
    }

    return (
        <div id='content' className={styles.modal}>
            <h4 id='firstHeading' className={styles.modal_name}>
                {location?.name}
            </h4>
            <div id='bodyContent' className={styles.modal_body}>
                <LocationAddress phone={location?.formattedNumber} address={address} isModal={true} />
            </div>
            <button onClick={() => onDetailsClick(location.locationId)} type='button' className={styles.modal_button} id='moreDetails'>
                <div>{localizations.moreDetails}</div>
                <ArrowRight />
            </button>
        </div>
    )
}

InfoWindowBody.propTypes = {
    location: PropTypes.object,
    localizations: PropTypes.object,
    onDetailsClick: PropTypes.func,
}

export default InfoWindowBody
